<template>
  <section class="blog">
    <Hero />
    <section class="px-4 py-5">
      <div class="container">
        <Posts />
      </div>
    </section>
  </section>
</template>

<script>
import { useHead } from "@vueuse/head";
import { defineComponent, computed, reactive } from "vue";
import Hero from "@/components/views/blog/hero.vue";
import Posts from "@/components/views/blog/posts.vue";
export default defineComponent({
  setup() {
    const siteData = reactive({
      title: "Blog | Zoinix Inter Technology",
      url: "https://zoinix.com/blog",
    });

    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: "og:title",
          content: computed(() => siteData.title),
        },
        {
          name: "tw:title",
          content: computed(() => siteData.title),
        },
        {
          name: "og:url",
          content: computed(() => siteData.url),
        },
        {
          name: "twitter:url",
          content: computed(() => siteData.url),
        },
      ],
    });
  },
  components: { Hero, Posts },
});
</script>
